/* eslint-disable no-console */

import axios from "axios";
import Store from "store";

import { showResponseMessageError } from "../../index";
import userActionCreators from "../../../action-creators/user";
import common from "./Common";
import endpoints from "../../../configs/endpoints";

class Request {
  constructor(baseURL) {
    // Init cancelToken. Note: Must create cancel token for each request
    this.cancelToken = axios.CancelToken;
    this.source = this.cancelToken.source();
    this.instance = axios.create({
      baseURL,
      timeout: 1000,
    });
    this.showAlert = true;
  }

   get(url, params = {}, configsInput = {}, _, showAlert = true) {
    this.showAlert = showAlert;
    const { urlProcess, allParams, configs } = common.getURL(
      url,
      params,
      configsInput,
    );
    return axios
      .get(urlProcess, {
        params: allParams,
        ...configs,
      })
      .then((response) => {
        const ret = response && response.data;
        return ret;
      })
      .catch(this.handleError.bind(this));
  }

  downloadCSV(
    url,
    params,
    configsInput = { headers: {} },
    _,
    showAlert = true,
  ) {
    const { urlProcess, allParams, configs } = common.getURL(
      url,
      params,
      configsInput,
    );
    this.showAlert = showAlert;
    return axios
      .get(urlProcess, {
        params: allParams,
        ...configs,
      })
      .then((response) => {
        const ret = response && response.data;
        const objURL = window.URL.createObjectURL(new Blob([ret]));
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = objURL;
        // the filename you want
        a.download = "report.csv";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objURL);
        return null;
      })
      .catch(this.handleError.bind(this));
  }

  post(url, params, configsInput, _, showAlert = true, returnFullResponse) {
    const { urlProcess, allParams, configs } = common.getURL(
      url,
      params,
      configsInput,
    );
    this.showAlert = showAlert;
    return axios
      .post(urlProcess, allParams, configs)
      .then((response) => {
        // process.env.NODE_ENV === "development" && console.info(response);
        const ret = response && response.data;
        return returnFullResponse ? response : ret;
      })
      .catch(this.handleError.bind(this));
  }

  put(url, params, configsInput, _, showAlert = true, returnFullResponse) {
    const { urlProcess, allParams, configs } = common.getURL(
      url,
      params,
      configsInput,
    );
    this.showAlert = showAlert;
    return axios
      .put(urlProcess, allParams, configs)
      .then((response) => {
        process.env.NODE_ENV === "development" && console.info(response);
        const ret = response && response.data;
        return returnFullResponse ? response : ret;
      })
      .catch(this.handleError.bind(this));
  }

  delete(url, params, configsInput, _, showAlert = true) {
    const { urlProcess, allParams, configs } = common.getURL(
      url,
      params,
      configsInput,
    );
    this.showAlert = showAlert;
    return axios
      .delete(urlProcess, {
        params: allParams,
        ...configs,
      })
      .then((response) => {
        process.env.NODE_ENV === "development" && console.info(response);
        const ret = response && response.data;
        return ret;
      })
      .catch(this.handleError.bind(this));
  }

  upload(url, formData, configsInput, _, showAlert = true) {
    const { urlProcess, configs } = common.getURL(url, {}, configsInput);
    this.showAlert = showAlert;
    return axios
      .put(urlProcess, formData, {
        headers: {
          ...configs.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        process.env.NODE_ENV === "development" && console.info(response);
        const ret = response && response.data;
        return ret;
      })
      .catch(this.handleError.bind(this));
  }

  uploadFile(url, formData, configsInput, _, showAlert = true) {
    const { urlProcess, configs } = common.getURL(url, {}, configsInput);
    this.showAlert = showAlert;
    return axios
      .post(urlProcess, formData, {
        headers: {
          ...configs.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        process.env.NODE_ENV === "development" && console.info(response);
        const ret = response && response.data;
        return ret;
      })
      .catch(this.handleError.bind(this));
  }

  async handleError(error) {
    const { config } = error;
    // eslint-disable-next-line eqeqeq
    if (error.response?.status == 401) {
      const { refreshToken } = Store.getState().user;

      if (!config._retry && refreshToken) {
        config._retry = true;

        const res = await this.post(
          endpoints.user.refreshToken,
          { refresh_token: refreshToken },
          {},
          false,
          false,
        );
        if (!res.token) {
          return Store.dispatch(userActionCreators.logout());
        }
        Store.dispatch(userActionCreators.setToken(res));

        const ret = await this.instance({
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${res.token}`,
          },
        });

        return ret.data;
      }
    }
    this.showAlert && showResponseMessageError(error.response);
    return error.response;
  }

  // Cancel request by token request
  actionCancel() {
    this.source && this.source.cancel("Operation canceled by the user.");
  }
}

export default new Request();
